import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-160271f1")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12 p-grid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "p-col-12 p-text-right" }, "El gráfico muestra la evolución del rating de cada área por clase", -1)
const _hoisted_4 = { class: "p-col-12" }
const _hoisted_5 = { class: "p-col-12 p-grid" }
const _hoisted_6 = { class: "p-lg-5 p-md-12" }
const _hoisted_7 = { class: "p-lg-7 p-md-12" }
const _hoisted_8 = { class: "p-col-12" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClassRatingChartByDate = _resolveComponent("ClassRatingChartByDate")!
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_NPSScoreTable = _resolveComponent("NPSScoreTable")!
  const _component_NPSRankTable = _resolveComponent("NPSRankTable")!
  const _component_NPSCommentBox = _resolveComponent("NPSCommentBox")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ClassRatingChartByDate, {
          loading: _ctx.loading,
          course: _ctx.course,
          summaries: _ctx.summaries
        }, null, 8, ["loading", "course", "summaries"])
      ])
    ]),
    _createElementVNode("article", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.loadingTables)
          ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
          : (_openBlock(), _createBlock(_component_NPSScoreTable, {
              key: 1,
              npsScore: _ctx.NPSComments?.score?.value,
              detractors: _ctx.NPSComments?.detractors,
              passives: _ctx.NPSComments?.passives,
              promoters: _ctx.NPSComments?.promoters
            }, null, 8, ["npsScore", "detractors", "passives", "promoters"]))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.loadingTables)
          ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
          : (_openBlock(), _createBlock(_component_NPSRankTable, {
              key: 1,
              total: _ctx.NPSComments.comments.length,
              students: _ctx.studentsRef,
              ranks: _ctx.NPSComments?.ranks,
              responses: _ctx.NPSComments?.comments.length
            }, null, 8, ["total", "students", "ranks", "responses"]))
      ])
    ]),
    _createElementVNode("article", _hoisted_8, [
      (_ctx.loadingFeedbacks)
        ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
        : (_openBlock(), _createBlock(_component_NPSCommentBox, {
            key: 1,
            feedbacks: _ctx.npsFeedbacks,
            avgNPS: _ctx.avgNPS,
            NPSComments: _ctx.NPSComments.comments
          }, null, 8, ["feedbacks", "avgNPS", "NPSComments"]))
    ])
  ]))
}